export interface TooltipRect {
  left: number;
  right: number;
  top: number;
  bottom: number;
  width: number;
  height: number;
}

export interface StatusTooltipPosition {
  left: number;
  top: number;
  arrowLeft: number;
}

interface GetStatusTooltipPositionParams {
  triggerRect: TooltipRect;
  tooltipRect: TooltipRect;
  boundaryRect?: TooltipRect;
  viewportWidth: number;
}

const STATUS_TOOLTIP_VIEWPORT_PADDING = 8;
const STATUS_TOOLTIP_BOUNDARY_PADDING = 8;
const STATUS_TOOLTIP_GAP = 8;
const STATUS_TOOLTIP_ARROW_PADDING = 8;

export const getStatusTooltipPosition = ({
  triggerRect,
  tooltipRect,
  boundaryRect,
  viewportWidth,
}: GetStatusTooltipPositionParams): StatusTooltipPosition => {
  const boundaryLeft = boundaryRect
    ? Math.max(
        boundaryRect.left + STATUS_TOOLTIP_BOUNDARY_PADDING,
        STATUS_TOOLTIP_VIEWPORT_PADDING,
      )
    : STATUS_TOOLTIP_VIEWPORT_PADDING;
  const boundaryRight = boundaryRect
    ? Math.min(
        boundaryRect.right - STATUS_TOOLTIP_BOUNDARY_PADDING,
        viewportWidth - STATUS_TOOLTIP_VIEWPORT_PADDING,
      )
    : viewportWidth - STATUS_TOOLTIP_VIEWPORT_PADDING;

  const triggerCenter = triggerRect.left + triggerRect.width / 2;
  const centeredLeft = triggerCenter - tooltipRect.width / 2;
  const availableBoundaryWidth = boundaryRight - boundaryLeft;

  const left =
    availableBoundaryWidth >= tooltipRect.width
      ? Math.min(
          Math.max(centeredLeft, boundaryLeft),
          boundaryRight - tooltipRect.width,
        )
      : Math.max(
          STATUS_TOOLTIP_VIEWPORT_PADDING,
          Math.min(
            centeredLeft,
            viewportWidth - tooltipRect.width - STATUS_TOOLTIP_VIEWPORT_PADDING,
          ),
        );

  const top = Math.max(
    STATUS_TOOLTIP_VIEWPORT_PADDING,
    triggerRect.top - tooltipRect.height - STATUS_TOOLTIP_GAP,
  );

  const arrowLeft = Math.min(
    Math.max(triggerCenter - left, STATUS_TOOLTIP_ARROW_PADDING),
    tooltipRect.width - STATUS_TOOLTIP_ARROW_PADDING,
  );

  return {
    left,
    top,
    arrowLeft,
  };
};
